import React, { useEffect, useRef, useState } from "react";
import { ToastContainer } from "react-toastify";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { getIcons } from "../../Constant/Constant";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import marketingHubService from "../../Services/MarketingHubService";
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "../../Constant/Notification";
import Loader from "../../Constant/Loader";
import CustomHeading from "../../common/CustomHeading";

const MarketingHub = () => {
  const icons = getIcons();
  const [searchTerm, setSearchTerm] = useState("");
  const [group, setGroup] = useState([]);
  const [filteredGroup, setFilteredGroup] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [updateGroupName, setUpdateGroupName] = useState("");
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [newGroupName, setNewGroupName] = useState("");
  const [newSelectedProperties, setNewSelectedProparties] = useState("");

  const [isOpen, setIsOpen] = useState(false);
  const [selectedProperties, setSelectedProperties] = useState(
    "All Property",
  );

  const [isOpenSearch, setIsOpenSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const dropdownRef = useRef(null);

  const options = ["Property A", "Property B", "Property C", "Property D"];

  // Close dropdown if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const properties = [
    "All Property",
    "Sersa glory",
    "Leme sea shore",
    "Piloe block",
    "Resourt block",
    "Me you village",
  ];

  const handleSelect = (property) => {
    setSelectedProperties(property); 
  };
  

  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  const navigate = useNavigate();

  const fetchGroupData = async () => {
    setLoading(true);
    try {
      const response = await marketingHubService.fetchGroups();
      setGroup(response.data);
      setFilteredGroup(response.data);
    } catch (error) {
      showErrorToast(error.response.data);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchGroupData();
  }, []);
  //   const handleSearchChange = (event) => {
  //     setSearchTerm(event.target.value);
  //     const filtered = group.filter((group) =>
  //       group.name.toLowerCase().includes(event.target.value.toLowerCase())
  //     );
  //     setFilteredGroup(filtered);
  //   };

  const handleCreateGroupModal = () => {
    setIsModalOpen(true);
  };

  const handleGroupInfo = (group) => {
    const groupName = group.name;
    const groupId = group.id;
    console.log(groupName);

    if (userRole === "Admin") {
      navigate(`/admin/marketingHub-groupinfo/${group.id}`, {
        state: { group: groupName, groupId: groupId },
      });
    } else if (userRole === "CMO") {
      navigate(`/cmo/marketingHub-groupinfo/${group.id}`, {
        state: { group: groupName, groupId: groupId },
      });
    }
  };
  const handleUpdateGroupModal = (group) => {
    setSelectedGroup(group);
    setUpdateGroupName(group.name);
    setIsUpdateModalOpen(true);
  };

  // Custom styles for Modal
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "751px",
      padding: "30px",
      position: "relative",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
       zIndex: 50
    },
  };

  // Bind modal to your appElement
  Modal.setAppElement("#root");
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setNewGroupName("");
    // setErrors({});
  };

  const handleCreateGroup = async (e) => {
    // e.preventdefault();
    setLoading(true);
    const groupData = { name: newGroupName.trim() };
    try {
      const response = await marketingHubService.createGroup(groupData);
      setGroup([...group, response.data]);
      await fetchGroupData();
      handleCloseModal();
      showSuccessToast("Group Created Successfully");
    } catch (error) {
      showErrorToast(error.response.data);
    } finally {
      setLoading(false);
    }
  };
  const handleCloseUpdateModal = () => {
    setIsUpdateModalOpen(false);
    setNewGroupName("");
  };
  const handleUpdateGroup = async (group) => {
    setLoading(true);
    const groupData = {
      name: updateGroupName.trim(),
      groupId: selectedGroup.id,
    };
    try {
      const response = await marketingHubService.updateGroup(groupData);
      await fetchGroupData();
      handleCloseUpdateModal();
      showSuccessToast("Group Updated Successfully");
    } catch (error) {
      showErrorToast(error.response.data);

      console.error("There was an error updating the Group:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-appGrayBackground  pb-10 pt-20">
      {loading ? <Loader /> : ""}
      <AdminAppBar />
      <ToastContainer />

      <div className="mt-10 px-20 xl:px-6 relative flex justify-between gap-5">
        <div>
          <CustomHeading title={`Content Hub (${group.length})` } isIcon={true} />
        </div>

        <div className="relative flex w-[700px] 4xl:w-[1600px] 2xl:w-[900px] 3xl:w-[1300px] items-center ">
          <img
            src={icons.searchIcon}
            alt=""
            className="absolute left-4 w-5 h-5"
          />
          <input
            type="text"
            placeholder="Search Team"
            value={searchTerm}
            //      onChange={handleSearchChange}
            className="setup-search pl-10 pr-4  h-10 border-stone-400 shadow appearance-none border rounded text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>

        <div className="relative inline-block">
          {/* Filter Button */}
          <div
            className="bg-white flex cursor-pointer border-2 border-stone-400 items-center w-52 p-2 rounded-md"
            onClick={() => setIsOpen(!isOpen)}
          >
            <img src={icons?.filterIcon} className="w-5 h-5 mr-2" />
            <div>: {selectedProperties}</div>
          </div>

          {isOpen && (
            <div className="absolute left-0 mt-2 w-52 z-40 bg-white shadow-lg border border-gray-300 rounded-md p-2">
              {properties.map((property) => (
                <label
                  key={property}
                  className="flex items-center p-2 cursor-pointer hover:bg-gray-100 rounded-md"
                >
                  <input
                    type="radio"
                    name="property"
                    value={property}
                    checked={selectedProperties.includes(property)}
                    onChange={() => handleSelect(property)}
                    className="mr-2 accent-gray-700"
                  />
                  {property}
                </label>
              ))}

              <div className="flex justify-between mt-2">
                <button
                  className="bg-customGreen text-white px-4 py-1 rounded-md"
                  onClick={() => setIsOpen(false)}
                >
                  Ok
                </button>
                <button
                  className="bg-gray-400 text-white px-4 py-1 rounded-md"
                  onClick={() => setIsOpen(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>

        <div>
          <button
            onClick={handleCreateGroupModal}
            className="border-2 whitespace-nowrap border-customGreen rounded-sm p-1 px-5 w-fit text-lg text-customGreen h-10 text-center"
          >
            +Create a New Group
          </button>
        </div>
      </div>

      <div className="list-container bg-white mt-10 rounded-md shadow-md w-12/12 pt-6 mx-20 xl:mx-6 pb-6">
        <div className="list-scroller overflow-y-auto max-h-[500px]  3xl:max-h-[850px] 4xl:max-h-[750px] custom-scrollbar">
          <table className="w-full table-fixed">
            <thead className="bg-white sticky top-0">
              <tr className="border-b ">
                <th className="text-customGreen text-2xl 4xl:text-3xl">
                  Material Group
                </th>
                <th className="text-customGreen text-2xl 4xl:text-3xl">
                  Messages
                </th>
                <th className="text-customGreen text-2xl 4xl:text-3xl">
                  Image
                </th>
                <th className="text-customGreen text-2xl 4xl:text-3xl">
                  Documents
                </th>
                <th className="text-customGreen text-2xl 4xl:text-3xl">
                  Links
                </th>

                <th className="w-20"></th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(filteredGroup) && filteredGroup.length > 0 ? (
                filteredGroup.map((group) => (
                  <tr
                    key={group.id}
                    className="text-center px-20 w-full font-medium border-b xl:text-sm 3xl:text-lg 4xl:text-2xl"
                  >
                    <td
                      className="text-center text-[#2280FF] hover:text-[#223fff] flex ml-20 xl:ml-14 custom-xl:ml-16 4xl:ml-36 py-5 cursor-pointer"
                      onClick={() => handleGroupInfo(group)}
                    >
                      <div className="flex items-center justify-center">
                        <span
                          className="text-4xl text-customGreen"
                          style={{ minWidth: "1em" }}
                        >
                          &bull;
                        </span>
                        <span className="text-start">{group.name}</span>
                      </div>
                    </td>
                    <td>{group.textCount}</td>
                    <td>{group.documentsCount}</td>
                    <td>{group.textCount}</td>
                    <td>{group.textCount}</td>

                    <td
        className="text-sky-400 cursor-pointer"
        onClick={() => handleUpdateGroupModal(group)}
      >
        Edit
      </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="4"
                    className="text-center text-red-500 py-5 font-medium"
                  >
                    No Data Available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Create Team Modal */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        contentLabel="Create Group"
        style={customStyles}
      >
        <div className="flex items-center justify-between">
          <div className="text-3xl font-medium text-center ">
            Enter New Group Name
          </div>
          <button
            onClick={handleCloseModal}
            className="text-[40px] text-gray-700"
          >
            &times;
          </button>
        </div>

        <form onSubmit={handleCreateGroup}>
          <div className="mb-4 flex gap-8 mt-[56px]">
            <label
              className="block text-gray-700 text-xl text-nowrap font-normal mb-2"
              htmlFor="name"
            >
              New Group Name
            </label>
            <input
              type="text"
              id="name"
              value={newGroupName}
              placeholder="Enter a Team Name"
              onChange={(e) =>
                setNewGroupName(
                  e.target.value.charAt(0).toUpperCase() +
                    e.target.value.slice(1)
                )
              }
              className="shadow appearance-none border rounded w-full h-10  px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
          <div className="relative " ref={dropdownRef}>
            <div className="mb-4 flex gap-14">
              <label className="block text-gray-700 text-xl font-normal mb-2 whitespace-nowrap">
                Select Property
              </label>
              <div className="relative w-full">
                <input
                  type="text"
                  id="name"
                  value={newSelectedProperties}
                  placeholder="Enter a Team Name"
                  onFocus={() => setIsOpenSearch(true)}
                  onChange={(e) =>
                    setNewSelectedProparties(
                      e.target.value.charAt(0).toUpperCase() +
                        e.target.value.slice(1)
                    )
                  }
                  className="shadow border rounded w-full h-10 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
                {isOpenSearch && (
                  <div className=" top-full left-0 mt-1 w-full bg-stone-100 border shadow-lg rounded-md z-10">
                    <div className="px-2 mt-2">
                      <div className="relative w-full">
                        <img
                          src={icons?.searchIcon}
                          className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500"
                          alt="Search"
                        />

                        <input
                          type="text"
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          className="w-full pl-10 pr-3 py-2 border rounded-md text-gray-700 focus:outline-none"
                        />
                      </div>
                    </div>
                    <ul className="max-h-40 overflow-y-auto">
                      {options
                        .filter((option) =>
                          option
                            .toLowerCase()
                            .includes(searchQuery.toLowerCase())
                        )
                        .map((option, index) => (
                          <li
                            key={index}
                            className="p-2 hover:bg-gray-200 cursor-pointer"
                            onClick={() => {
                              setNewSelectedProparties(option);
                              setIsOpenSearch(false);
                            }}
                          >
                            {option}
                          </li>
                        ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="flex justify-end mt-10">
            {/* <button
              type="submit"
              className='bg-customGreen hover:bg-customGreen-dark text-lg text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'
            >
              Create Team
            </button> */}
            <button
              onClick={handleCreateGroup}
              className="bg-customGreen text-white px-4 md:h-9 l lg:h-11 rounded-md md:text-xl lg:text-2xl font-medium"
              disabled={loading} // Disable button while loading
            >
              Done
            </button>
          </div>
        </form>
      </Modal>

      {/* Update Team Modal */}
      <Modal
        isOpen={isUpdateModalOpen}
        onRequestClose={handleCloseUpdateModal}
        contentLabel="Update Group"
        style={customStyles}
      >
        <button
          onClick={handleCloseUpdateModal}
          className="absolute top-2 right-2 text-2xl text-gray-700"
        >
          &times;
        </button>
        <h2 className="text-3xl font-semibold mb-4">Update Group</h2>
        <form onSubmit={handleUpdateGroup}>
          <div className="mb-4">
            <label
              className="block text-gray-700 text-xl font-bold mb-2"
              htmlFor="update-name"
            >
              Group Name
            </label>
            <input
              type="text"
              id="update-name"
              value={updateGroupName}
              placeholder="Enter a Team Name"
              onChange={(e) =>
                setUpdateGroupName(
                  e.target.value.charAt(0).toUpperCase() +
                    e.target.value.slice(1)
                )
              }
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
          <div className="flex justify-end">
            {/* <button
              type="submit"
              className='bg-customGreen hover:bg-customGreen-dark text-lg text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'
            >
              Update Team
            </button> */}
            <button
              onClick={handleUpdateGroup}
              className="bg-customGreen text-white md:w-28 md:h-9 lg:w-48 lg:h-11 rounded-md md:text-xl lg:text-2xl font-medium"
              disabled={loading} // Disable button while loading
            >
              Update
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default MarketingHub;
